import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { FeedItem } from '@/features/announcements/types'

export interface ChartPoint {
  label: string
  value: number
}

export interface DashboardData {
  academicYear: { id: number; name: string; startsOn: string; endsOn: string } | null
  kpis: {
    activeStudents: number
    inactiveStudents: number
    activeStaff: number
    classes: number
    sections: number
    seatCapacity: number
    occupancy: number | null
  }
  studentsByClass: ChartPoint[]
  studentsByGender: ChartPoint[]
  staffByDepartment: ChartPoint[]
  admissionsByMonth: (ChartPoint & { month: string })[]
  recentStudents: {
    id: number
    fullName: string
    studentCode: string
    className: string | null
    photoUrl: string | null
    admissionDate: string
  }[]
  generatedAt: string
  /** Module sections are null when the viewer lacks that module's permission. */
  attendanceToday: {
    date: string
    isWorkingDay: boolean
    marked: number
    present: number
    absent: number
    late: number
    excused: number
    halfDay: number
    rate: number | null
    sectionsMarked: number
    sectionsTotal: number
  } | null
  announcements: FeedItem[]
  finance: {
    collectedThisMonth: string
    outstandingTotal: string
    overdueCount: number
    overdueTotal: string
    invoicesThisMonth: number
    collectionsByMonth: { month: string; label: string; value: number }[]
  } | null
  upcomingExams:
    | {
        id: number
        name: string
        examType: string
        status: string
        startsOn: string
        endsOn: string
        classCount: number
        marksEntered: number
        marksExpected: number
      }[]
    | null
  pendingLeave: number | null
  library: {
    titles: number
    copies: number
    onLoan: number
    overdue: number
    finesOutstanding: string
  } | null
}

export const dashboardQuery = () =>
  queryOptions({ queryKey: ['dashboard'], queryFn: () => api.get<DashboardData>('/dashboard') })
